export async function getSalesReps() {
    try {
        const response = await fetch('https://eyr9stj8lh.execute-api.ap-southeast-1.amazonaws.com/prod/getSalesReps', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (response.ok) {
            const data = await response.json();

            // Access the salesReps array within the data object
            const salesRepsArray = data.salesReps;
            if (Array.isArray(salesRepsArray)) {
                const sortedSalesReps = salesRepsArray.sort((a, b) => a.lastname.localeCompare(b.lastname));
                return sortedSalesReps;
            } else {
                console.error("Unexpected data format: salesReps is not an array.");
                return null;
            }
        } else {
            console.error(`Error: Failed to fetch sales representatives. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        console.error('Error: Network or other error occurred while fetching sales representatives.', error);
        return null;
    }
}


export async function getSalesRep(id) {
    try {
        // Make the API call using the id
        const response = await fetch(`https://xd8p7gx9ld.execute-api.ap-southeast-1.amazonaws.com/prod/getSalesRep/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        // Check for a successful response
        if (response.ok) {
            const data = await response.json();
            return data;  // Return the sales rep data (assuming it's a single object)
        } else {
            console.error(`Error: Failed to fetch sales representative by id. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        // Catch any network or other errors
        console.error('Error: Network or other error occurred while fetching sales representative by id.', error);
        return null;
    }
}

